import Location from '@solvhealth/types/interfaces/Location';
import { getQueryParams } from '~/core/util/url';
import { getSlotIfExists } from '~/core/location/slots';
import { analyticsTrackEvent } from '~/core/analytics';
import { CDP_BOOK_MODULE_ACTION } from '~/core/analytics/events';

export const checkAppointmentDateQueryParam = (location: Location) => {
  const queryParams = getQueryParams();
  const queryAppointmentTimeStamp = parseInt(queryParams?.appointment_date, 10);
  const queryAppointment = getSlotIfExists(queryAppointmentTimeStamp, location);

  // we track if the QP is a valid slot and if it's availble
  // to get the % of marys who land on an occupied slot
  // so that we can track the % of cache misses and adjust accordingly
  if (queryAppointment) {
    analyticsTrackEvent(CDP_BOOK_MODULE_ACTION.SLOT_RECEIVED_FROM_QUERY_PARAM, {
      locationId: location?.id,
      appointmentDate: queryAppointment?.appointmentDate,
    });
  }

  if (queryAppointment?.availability === 0) {
    analyticsTrackEvent(CDP_BOOK_MODULE_ACTION.APPOINTMENT_DATE_QUERY_PARAM_OCCUPIED, {
      locationId: location?.id,
      appointmentDate: queryAppointment?.appointmentDate,
    });

    return null;
  }

  return queryAppointment;
};
